import { HttpDownloadProgressEvent, HttpEvent, HttpEventType } from '@angular/common/http';
import { filter, mergeMap, OperatorFunction, pipe, scan } from 'rxjs';

/** One SSE frame: the `id:` line and the raw `data:` payload. */
export interface SseEvent {
    id: string;
    data: string;
}

interface ParseState {
    offset: number;
    events: SseEvent[];
}

/** Turns a `observe: 'events', responseType: 'text', reportDownloadProgress: true` stream into SSE frames. */
export function sseEvents(): OperatorFunction<HttpEvent<string>, SseEvent> {
    return pipe(
        filter((event): event is HttpDownloadProgressEvent => event.type === HttpEventType.DownloadProgress),
        // partialText is cumulative — offset tracks the end of the last complete frame
        scan((state: ParseState, event) => parseFrames(event.partialText ?? '', state.offset), { offset: 0, events: [] }),
        mergeMap(({ events }) => events),
    );
}

// frames end with "\n\n"; lines are `id: …`, `data: …` or `:` heartbeats (no `event:` field in these streams)
function parseFrames(text: string, offset: number): ParseState {
    const events: SseEvent[] = [];
    let end = text.indexOf('\n\n', offset);

    while (end !== -1) {
        let id = '';
        let data = '';
        for (const line of text.slice(offset, end).split('\n')) {
            if (line.startsWith('id:')) {
                id = line.slice(3).trim();
            } else if (line.startsWith('data:')) {
                data = line.slice(5).trim();
            }
        }
        if (id && data) {
            events.push({ id, data });
        }
        offset = end + 2;
        end = text.indexOf('\n\n', offset);
    }

    return { offset, events };
}
